module.exports = __webpack_public_path__ + "img/pr_jobsuite.eecff66a.png";